import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const getMappingDetails = async (id) => {
  const path = `/mappings/${id}/`;
  try {
    const response = await axiosInstance.get(path);
    return response.data;
  } catch (error) {
    console.error('Mapping Details API error:', error);
    throw error;
  }
};

export const useGetMappingDetails = (id) => {
  const enabled = !!id && id !== 'new';
  const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['mappings', id],
    queryFn: () => getMappingDetails(id),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    enabled,
  });
  return {
    mappingData: data,
    error,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
};
